import { CommonErrorCode } from '@common/interfaces/logging/CommonErrorCodes';

export class CommonError extends Error {
  public readonly isCommonError = true;

  /**
   * An error code to help us figure out what kind of error this actually is.
   */
  public readonly code: CommonErrorCode;

  public readonly name: string;

  public readonly cause?: Error;

  constructor(code: CommonErrorCode, message: string, name?: string, cause?: Error) {
    super(message);
    this.code = code;
    this.name = name ?? this.constructor.name;
    this.cause = cause;

    Object.setPrototypeOf(this, CommonError);
  }
}

/**
 * Detects that the error is a common error
 * @param error The error to detect
 */
export function isCommonError(error: unknown): error is CommonError {
  return (error as CommonError)?.isCommonError;
}
